var _path, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99953 0.0104513C4.84402 0.154433 0.736567 1.42012 0.0637379 5.52792C-0.613602 9.66326 4.28203 15.2938 6.99953 17.7729V17.9544C7.0327 17.9248 7.06625 17.8948 7.10017 17.8642C7.13409 17.8948 7.16764 17.9248 7.2008 17.9543V17.7729C9.9183 15.2938 14.8139 9.66328 14.1366 5.52794C13.4638 1.42014 9.35631 0.15445 7.2008 0.0104685V0C7.16776 0.00120393 7.13415 0.00269189 7.1 0.00447134C7.06596 0.00269948 7.03247 0.00121723 6.99953 1.71661e-05V0.0104513Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.79696,
    cy: 2.64975,
    rx: 2.79696,
    ry: 2.64975,
    transform: "matrix(-1 0 0 1 9.99805 4.02032)",
    fill: "#2E6EEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.fd2c2339b72f018864f6ac2887013031.svg";
export { ForwardRef as ReactComponent };